export default "__VITE_ASSET__BVTFIy8x__"